import { Converter } from '../types/converter';

export const fuelEfficiencyMassConverter: Converter = {
  id: 'fuelEfficiencyMass',
  name: 'Mass Fuel Efficiency Converter',
  icon: 'Fuel',
  categories: ['engineering'],
  units: [
    // Energy per mass units
    { name: 'Joule per kilogram', symbol: 'J/kg', factor: 1 },
    { name: 'Kilojoule per kilogram', symbol: 'kJ/kg', factor: 1000 },
    { name: 'Calorie (IT) per gram', symbol: 'cal/g', factor: 4186.8 },
    { name: 'Calorie (th) per gram', symbol: 'cal (th)/g', factor: 4184 },
    { name: 'Btu (IT) per pound', symbol: 'Btu/lb', factor: 2326 },
    { name: 'Btu (th) per pound', symbol: 'Btu (th)/lb', factor: 2324.444 },
    
    // Mass per energy units
    { name: 'Kilogram per joule', symbol: 'kg/J', factor: 1 },
    { name: 'Kilogram per kilojoule', symbol: 'kg/kJ', factor: 0.001 },
    { name: 'Gram per calorie (IT)', symbol: 'g/cal', factor: 0.000238846 },
    { name: 'Gram per calorie (th)', symbol: 'g/cal (th)', factor: 0.000239006 },
    { name: 'Pound per Btu (IT)', symbol: 'lb/Btu', factor: 0.00043 },
    { name: 'Pound per Btu (th)', symbol: 'lb/Btu (th)', factor: 0.00043 },
    
    // Power-based units
    { name: 'Pound per horsepower/hour', symbol: 'lb/hp·hr', factor: 0.608277 },
    { name: 'Gram per horsepower (metric)/hour', symbol: 'g/hp·hr', factor: 0.27 },
    { name: 'Gram per kilowatt/hour', symbol: 'g/kWh', factor: 0.277778 }
  ]
};
